import { render, staticRenderFns } from "./AdvertiserAccountRevshareHelperForm.vue?vue&type=template&id=4a812276"
import script from "./AdvertiserAccountRevshareHelperForm.vue?vue&type=script&lang=js"
export * from "./AdvertiserAccountRevshareHelperForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports